<template>
    <div class="opui-search-input opui-input-group-append" :class="{ 'opui-search-input-open': showDropdown }">
        <span class="opui-input-group-text" v-if="hideInput"><a href="#" @click.prevent="toggleDropdown"><i class="opui-fa opui-fa-database"></i></a></span>

        <div class="opui-form-group" v-else>
            <div class="opui-input-group">
                <input type="text" class="opui-form-control" :placeholder="placeholder" />
                <div class="opui-input-group-append">
                    <span class="opui-input-group-text"><a href="#" @click.prevent="toggleDropdown"><i class="opui-fa opui-fa-database"></i></a></span>
                </div>
            </div>
        </div>

        <div class="opui-search-input-options" v-if="showDropdown">
            <div class="opui-form-group">
                <div class="opui-input-group">
                    <input type="text" class="opui-form-control" :placeholder="'Search..'" @keydown="search" v-model="query" v-focus />
                    <div class="opui-input-group-append">
                        <span class="opui-input-group-text"><a href="#" @click.prevent="toggleDropdown"><i class="opui-fa opui-fa-search"></i></a></span>
                    </div>
                </div>
            </div>

            <div class="opui-search-input-options-loading" v-if="isLoading">{{ $e('Loading...') }}</div>

            <ul v-if="filteredOptions && ! isLoading">
                <li v-for="(option, index) in filteredOptions" :key="index">
                    <!-- If there are children inside the option, we need a accordion type UI -->
                    <div class="opui-search-input-group" v-if="option.children && option.children.length">
                        <a href="#" class="opui-search-input-group-toggle"
                             @click.prevent="toggleGroup('group_' + index)"
                        >
                            {{ option.label ? option.label : option.text }}
                            <span class="opui-search-input-group-arrow">
                                <i class="opui-fa opui-fa-sort-up" v-if="showGroup['group_' + index]"></i>
                                <i class="opui-fa opui-fa-sort-down" v-else></i>
                            </span>
                        </a>

                        <ul v-if="showGroup['group_' + index]">
                            <li v-for="child in option.children">
                                <a href="#"
                                   @click.prevent="select(child)"
                                   :data-value="child.value ? child.value : child.id"
                                   class="opui-search-input-option"
                                >
                                    {{ child.label ? child.label : child.text }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- If children are defined but empty, hide it -->
                    <div v-else-if="option.children && option.children.length === 0"></div>

                    <!--Else we show a simple option select -->
                    <a href="#"
                       @click.prevent="select(option)"
                       :data-value="option.value ? option.value : option.id"
                       class="opui-search-input-option"
                       v-else
                    >
                        {{ option.label ? option.label : option.text }}
                    </a>
                </li>
            </ul>

            <div v-else-if="! isLoading" class="opui-search-input-options-loading">No options were found</div>

            <!-- <p><small>GROUP: {{ showGroup }}</small></p>
            <p><small>FOPT: {{ filteredOptions }}</small></p>
            <p><small>LOPT: {{ loadedOptions }}</small></p>
            <p><small>OPT: {{ options }}</small></p> -->
        </div>

        <!--<p><small>SELECTED: {{ selected }}</small></p>
        <p><small>URL: {{ url }}</small></p>
        <p><small>OPTIONS: {{ options }}</small></p>
        <p><small>HIDE: {{ hideInput }}</small></p>-->
    </div>
</template>

<script>
export default {
    name: 'SearchDropdown',
    emits: ['change'],
    props: {
        label:       { type: String, required: false },
        placeholder: { type: String, required: false },
        url:         { type: String, required: false },
        options:     { type: Array, required: false },
        hideInput:   { type: Boolean, default: false },
    },
    data() {
        return {
            isLoading:     false,
            showDropdown:  false,
            showGroup:     {},
            loadedOptions: [],
            query:         '',
            selected:      null,
            filteredOptions: [],
            searchTimeout:  null,
        }
    },
    mounted() {
        this.$events.on('clickedOutside', () => {
            this.showDropdown = false
        })
    },
    computed: {

    },
    methods: {
        /**
         * Run search based on the search query
         */
        search() {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.filterOptions()
            }, 500)

        },

        filterOptions() {
            // console.log("FILTERING");
            let options         = []
            let filteredOptions = []

            // Now depending on the type of options copy the array
            if (this.url) {
                options = JSON.parse(JSON.stringify(this.loadedOptions))
            } else if (this.options) {
                options = JSON.parse(JSON.stringify(this.options))
            }
            // console.log(options);

            // Filter only if we have a query string
            if (this.query && options) {
                // Open all groups
                this.openAllGroups()

                // Assign all
                this.filteredOptions = [...options]

                this.filteredOptions = this.filteredOptions.filter((item) => {
                    // If it has children we only check children
                    if (item.children) {
                        item.children = item.children.filter((child) => {
                            // console.log("CHECK CH", child.text.toLowerCase(), this.query.toLowerCase(), child.text.toLowerCase().includes(this.query.toLowerCase()));

                            return child.text.toLowerCase().includes(this.query.toLowerCase());
                        })

                        return true
                    } else {
                        // console.log("CHECK", item.text.toLowerCase(), this.query.toLowerCase(), item.text.toLowerCase().includes(this.query.toLowerCase()));

                        return item.text.toLowerCase().includes(this.query.toLowerCase());
                    }

                    // Also filter children if needed




                })
            } else {
                // console.log("ALL");
                this.filteredOptions = [...options]
            }
        },

        openAllGroups() {
            [0,1,2,3,4,5,6,7,8,9].forEach((key) => {
                this.showGroup['group_' + key] = true
            })
        },

        /**
         * Load options from the URL
         */
        async loadOptions() {
            this.isLoading = true

            this.$http
                .get(this.url)
                .then(response => {
                    if (response.status === 200 && response.data) {
                        // console.log(response.data);
                        // console.log(response.data.results);

                        if (response.data.results) {
                            this.loadedOptions = response.data.results
                        } else {
                            this.loadedOptions = response.data
                        }

                        this.isLoading = false
                    } else {
                        this.$toast.error('Error when loading.')
                        this.isLoading = false
                    }
                    this.filterOptions()
                })
                .catch(e => {
                    this.filterOptions()
                    console.info('Error when loading options.', e)
                })
        },

        /**
         * Triggered when an option is selected
         * @param option
         */
        select(option) {
            this.selected = option
            this.$emit('change', option)
            this.showDropdown = false
        },

        /**
         * Toggle the dropdown
         */
        toggleDropdown() {
            if (! this.showDropdown) {
                this.$events.emit('clickedOutside')
            }

            this.showDropdown = ! this.showDropdown

            // Load options if needed
            if (this.showDropdown && this.url) {
                this.loadOptions()
            }
        },

        /**
         * Toggle group of options
         * @param group
         */
        toggleGroup(group) {
            this.showGroup[group] = ! this.showGroup[group]
        }
    }
}
</script>
